import React from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import Spinner from '../../common/spinner-container'
import useUserReflectionMutation from './use-user-reflection-mutation'

const EditReflectionForm = ({
    userReflection = {},
    userId,
    promptId,
    onComplete = () => {}
}) => {
    const {
        saveReflection,
        isSavingReflection,
        content,
        setContent
    } = useUserReflectionMutation({
        userId,
        promptId,
        content: userReflection.content,
        onSuccess: onComplete
    })

    if (isSavingReflection ) {
        return (<Spinner label='Saving reflection...' />)
    }

    return (
        <React.Fragment>
            <div style={{ padding: '20px', marginTop: '20px'}}>
                <Form.Group>
                    <Form.Label>{userReflection.name}</Form.Label>
                    <div style={{ whiteSpace: 'pre-wrap'}}>{userReflection.description}</div>
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Reflection:</Form.Label>
                    <Form.Control as="textarea" rows={5}
                        placeholder="Enter reflection here"
                        value={content}
                        onChange={e => setContent(e.target.value)}
                    />
                </Form.Group>
                <Row>
                    <Col xs={12}>
                        <Button block onClick={() => saveReflection()}>Save</Button>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default EditReflectionForm